export default function InventoryImagePlaceholder({ name }: { name: string }) {
  return (
    <div role="img" aria-label={`Placeholder image for ${name}`} className="flex h-full min-h-[64px] w-full flex-col items-center justify-center gap-1 rounded-lg bg-slate-100 p-3 text-slate-400">
      <svg aria-hidden="true" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="m12 3 9 5v8l-9 5-9-5V8l9-5Z" />
        <path d="m3 8 9 5 9-5M12 13v8M7.5 5.5l9 5" />
      </svg>
      <span className="text-xs">No photo yet</span>
    </div>
  );
}
